export default {
  BusinessStockDistributionPlan: {
    header: {
      code: '分仓计划单号',
      receiveWarehouseIdList: '接收仓',
    },
    page: '非审核页面',
    pageText1: '待审核状态下可修改，点击跳转修改分仓计划表单，自动带入当前分仓计划信息',
    pageText2: '审核拒绝以及已取消状态下可重置，重置后该分仓计划自动变为待审核状态',
    pageText3: '进行中的分仓计划可作废，作废后该计划不再执行，状态变更为已作废',
    btn: '作废',
    pageText4: '待审核状态下可取消，点击取消弹窗确认是否取消，确认取消后则取消所选分仓计划',
    reset: '重置',
    warehousePlan: '分仓计划',

    table: {
      code: '计划单号',
      receiveWarehouseName: '接收仓',
      planNum: '计划供应数量',
      alreadyNum: '已供应数量',
      priorityGrade: '优先级',
    }
  }
};
